//import Moment from "moment";

const getCount = (state) => {
	return state.produtos.length;
}

const possuiTipo = (produto, tipoProduto) => {
	return produto.tipos && produto.tipos.some((tipo) => Number(tipo) === tipoProduto);
}

const produtosSomente = (state) => {
	return state.produtos.filter((produto) => possuiTipo(produto, 1));
}

const servicosExternos = (state) => {
	return state.produtos.filter((produto) => possuiTipo(produto, 2));
}

const servicosInternos = (state) => {
	return state.produtos.filter((produto) => possuiTipo(produto, 3));
}

const produtosEServicosExternos = (state) => {
	return state.produtos.filter((produto) => possuiTipo(produto, 1) || possuiTipo(produto, 2));
}

const getStatusAtualizacaoLista = (state) => {
	if (state.ultimaAtualizacaoLista == null) {
		return true;
	}
	else if(!state.produtos)
	{
		return true;
	}
	else {
		const d = new Date();
		let hour = d.getHours();
		return (
			!state.listaCompletaCarregada ||
			state.produtos.length == 0 ||
			hour - state.ultimaAtualizacaoLista.getHours() > 0
		);
	}
}

export default {
	getCount,
	produtosSomente,
	servicosExternos,
	servicosInternos,
	produtosEServicosExternos,
	getStatusAtualizacaoLista
}
